import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import HelpCenter from "./components/HelpCenter";
import Login from "./pages/Login";
import TrustUserTicketStatus from "./pages/trustUserTicketStatus";
import JobDetailsPage from "./pages/userJobStatus";
import TrustAdminLogin from "./pages/TrustAdminLogin";
import BestBuy from "./pages/BestBuy";
import BestBuyAdmin from "./pages/BestBuyAdmin";
import MyContacts from "./pages/MyContacts";
import UtilityDashboard from "./pages/UtilityDashboard";
import TicketBooking from "./pages/TicketBooking";
import MarriageExpenseCalculator from "./pages/MarriageExpenseCalculator";
import CustomerSupport from "./pages/CustomerSupport";
import ProtectedRoute from './components/ProtectedRoute';
import MobileRecharge from "./pages/MobileRecharge";
import PayUs from "./pages/PayUs"; // Import the new component

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/bestBuy" element={<BestBuy />} />
        <Route path="/bestBuyAdmin" element={<BestBuyAdmin />} />
        {/* PROTECTED ROUTE FOR UTILITY DASHBOARD */}
        <Route
          path="/utility-dashboard"
          element={
            <ProtectedRoute>
              <UtilityDashboard />
            </ProtectedRoute>
          }
        />

        {/* PROTECTED ROUTE FOR MY CONTACTS */}
        <Route
          path="/my-contacts"
          element={
            <ProtectedRoute>
              <MyContacts />
            </ProtectedRoute>
          }
        />
        <Route path="/myContacts" element={<Navigate to="/my-contacts" replace />} />

        {/* PROTECTED ROUTE FOR TICKET BOOKING */}
        <Route
          path="/ticket-booking"
          element={
            <ProtectedRoute>
              <TicketBooking />
            </ProtectedRoute>
          }
        />

        {/* NEW PROTECTED ROUTE FOR MARRIAGE EXPENSE CALCULATOR */}
        <Route
          path="/marriage-expense-calculator"
          element={
            <ProtectedRoute>
              <MarriageExpenseCalculator />
            </ProtectedRoute>
          }
        />

        {/* PROTECTED ROUTE FOR CUSTOMER SUPPORT */}
        <Route
          path="/trustapp/customer-support"
          element={
            <ProtectedRoute>
              <CustomerSupport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mobile-recharge"
          element={
            <ProtectedRoute>
              <MobileRecharge />
            </ProtectedRoute>
          }
        />

        {/* NEW PROTECTED ROUTE FOR PAY US */}
        <Route
          path="/pay-us"
          element={
            <ProtectedRoute>
              <PayUs />
            </ProtectedRoute>
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/trustUserTicketStatus" element={<TrustUserTicketStatus />} />
        <Route path="/trustUserTicketStatus/:jobRunId" element={<TrustUserTicketStatus />} />
        <Route path="/HelpCenter" element={<HelpCenter />} />
        <Route
          path="/trustAdmin-login"
          element={
            <ProtectedRoute>
              <TrustAdminLogin />
            </ProtectedRoute>
          }
        />
        <Route path="/userJobStatus/:jobRunId" element={<JobDetailsPage />} />
        <Route path="/userJobStatus" element={<Navigate to="/userJobStatus/run-98765" replace />} />
      </Routes>
    </Router>
  );
}

export default App;